/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAirBoundsChangeRequest } from '../../models/finnair-air-bounds-change-request';
import { FinnairAirBoundsChangeResponse } from '../../models/finnair-air-bounds-change-response';

export interface FindAirBoundsChange$Params {
  orderId: string;
  hash?: string;
  locale?: string;
      body: FinnairAirBoundsChangeRequest
}

export function findAirBoundsChange(http: HttpClient, rootUrl: string, params: FindAirBoundsChange$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairAirBoundsChangeResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, findAirBoundsChange.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairAirBoundsChangeResponse>;
    }),
    catchErrorAsJson()
  );
}

findAirBoundsChange.PATH = '/api/change/{orderId}/airBounds';
